var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-view-container"},[_c('SentimentDayTiming',{attrs:{"title":"周期择时","subText":"节点把控-看图1","modal":"0","bottom-section-mask":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }